import i18n from '@/i18n'
import Layout from '../layout.vue'
import Index from './index'
import Editor from './editor.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const basePath = '/v-admin/job-posting-channel-account/management'
const i18nPrefix = 'admin.company.jobPostingChannelAccount'

export default {
  path: basePath,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: `${i18nPrefix}.title.jobPostingChannelAccountManagement`,
    permission: 'COMPUTED_COMPANY_HAS_MANUAL_JOB_POSTING_PREMIUM',
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.title.jobPostingChannelAccountManagement`)
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: `${i18nPrefix}.title.jobPostingChannelAccountManagement`,
        menu: {
          get label () {
            return i18n.t(`${i18nPrefix}.title.jobPostingChannelAccountManagement`)
          }
        }
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isEditMode: false,
        titleI18nKey: `${i18nPrefix}.title.jobPostingChannelAccountAdd`,
        menu: {
          get label () {
            return i18n.t(`${i18nPrefix}.title.jobPostingChannelAccountAdd`)
          }
        }
      }
    },
    {
      path: `${basePath}/edit/:id`,
      component: Editor,
      meta: {
        isEditMode: true,
        titleI18nKey: `${i18nPrefix}.title.jobPostingChannelAccountEdit`,
        menu: {
          get label () {
            return i18n.t(`${i18nPrefix}.title.jobPostingChannelAccountEdit`)
          }
        }
      }
    }
  ]
}
